import React from "react";
import { useTranslation } from "react-i18next";

import style from "./styles.module.scss";

const keyI18n = "translations.aboutPgm.anchors";

export interface AnchorItem {
  id: string;
  labelKey: string;
}

interface AnchorNavProps {
  items: AnchorItem[];
}

export default function AnchorNav({ items }: AnchorNavProps) {
  const { t } = useTranslation();

  return (
    <nav aria-label={t(`${keyI18n}.title`)} className={style.anchorNav}>
      <p className={`pgm-label-large ${style.title}`}>{t(`${keyI18n}.title`)}</p>
      <ul className={style.list}>
        {items.map(({ id, labelKey }) => (
          <li key={id}>
            <a className={`pgm-label-large ${style.link}`} href={`#${id}`}>
              {t(labelKey)}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
